import { useRouter } from 'next/router'

import { CustomSelect } from '@wartek-id/select'

import { DEFAULT_STATUS_PENGIRIMAN_FILTER } from 'app/KinerjaShared/stores/penetapan-predikat-kinerja-store'
import { STATUS_PENGIRIMAN_FILTER_LABELS } from 'app/KinerjaShared/components/PenetapanPredikatTable/constants'
import { usePenetapanPredikatTableStore } from 'app/KinerjaShared/components/PenetapanPredikatTable/Provider'

import type { StatusPengirimanFilterTypes } from 'app/KinerjaShared/stores/penetapan-predikat-kinerja-store'

export const PENGIRIMAN_FILTER_OPTIONS: Array<{
  value: StatusPengirimanFilterTypes
  name: string
}> = [
  { value: 'ALL', name: STATUS_PENGIRIMAN_FILTER_LABELS['ALL'] },
  { value: 'SENT', name: STATUS_PENGIRIMAN_FILTER_LABELS['SENT'] },
  { value: 'NOT_SENT', name: STATUS_PENGIRIMAN_FILTER_LABELS['NOT_SENT'] },
]

type StatusPengirimanFilterProps = {
  paramKey: string
}

export function StatusPengirimanFilter({
  paramKey,
}: StatusPengirimanFilterProps) {
  const router = useRouter()
  const { statusPengirimanFilter, setStatusPengirimanFilter } =
    usePenetapanPredikatTableStore((store) => ({
      statusPengirimanFilter: store.statusPengirimanFilter,
      setStatusPengirimanFilter: store.setStatusPengirimanFilter,
    }))

  const selected = PENGIRIMAN_FILTER_OPTIONS.find(
    (option) => option['value'] === statusPengirimanFilter
  )

  // Handle filter changes
  const handleFilterChange = (value: StatusPengirimanFilterTypes) => {
    // Update store
    setStatusPengirimanFilter(value)

    // Update URL
    const query = {
      ...router.query,
    }

    if (value !== DEFAULT_STATUS_PENGIRIMAN_FILTER) {
      query[paramKey] = value
    } else {
      delete query[paramKey]
    }

    router.replace(
      {
        pathname: router.pathname,
        query,
      },
      undefined,
      { shallow: true }
    )
  }

  return (
    <CustomSelect
      value={selected}
      options={PENGIRIMAN_FILTER_OPTIONS}
      className="text-nowrap min-w-64"
      onChange={(selectedOption) =>
        handleFilterChange(
          selectedOption['value'] as StatusPengirimanFilterTypes
        )
      }
    />
  )
}
